import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { filter, findIndex } from 'lodash';
import Button from 'components/form/Button';
import Card from 'components/Layout/Card';
import { getDataFromLocalStorage, objectToFormData } from 'utils/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { deleteMessage, fetchInboxMessage, starMessage } from 'store/slices';
import Compose from './Compose';
import List from './List';
import './InboxNotifications.scss';
import Notifications from './Notifications';
import Whatsapp from './Whatsapp';
import CallTracker from './CallTracker/CallTracker';
import NewList from './List/NewList';

const InboxNotifications = () => {
  const params = useParams();
  const { userDetails } = useSelector((state) => ({
    userDetails: state.student.userDetails,
  }));
  const { memberType, type, cType } = params;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [msgList, setMsgList] = useState([]);
  const [deleteIds, setDeleteIds] = useState([]);
  const getType = () => {
    switch (type === 'iferp' ? cType : type) {
      case 'inbox':
        return 'incoming';
      case 'sent-messages':
        return 'outgoing';
      case 'starred-messages':
        return 'starred';

      default:
        return '';
    }
  };
  const handelDeleteId = (id) => {
    if (deleteIds.includes(id)) {
      setDeleteIds(deleteIds.filter((o) => o !== id));
    } else {
      setDeleteIds([...deleteIds, id]);
    }
  };
  const getEmailList = async () => {
    const formData = objectToFormData({ type: getType() });
    const response = await dispatch(fetchInboxMessage(formData));
    setMsgList(response?.data || []);
    setIsLoading(false);
  };
  const handelDeleteMessage = async (data) => {
    setDeleteLoading(true);
    const formData = objectToFormData(data);
    const response = await dispatch(deleteMessage(formData));
    if (response?.status === 200) {
      setDeleteIds([]);
      const removeId = data?.index_array || [data.id];
      const newList = filter([...msgList], (el) => {
        return !removeId.includes(el.id);
      });
      setMsgList(newList);
    }
    setDeleteLoading(false);
  };
  const handelStarMessage = async (data) => {
    const formData = objectToFormData(data);
    const response = await dispatch(starMessage(formData));
    if (response?.status === 200) {
      const newList = [...msgList];
      const index = findIndex(newList, ['id', data.id]);
      newList[index].is_starred = data.status;
      setMsgList(newList);
    }
  };

  useEffect(() => {
    setDeleteIds([]);
    setMsgList([]);
    if (
      type !== 'compose' &&
      type !== 'notifications' &&
      type !== 'whatsapp' &&
      type !== 'call-tracker' &&
      cType !== 'compose' &&
      cType !== 'notifications'
    ) {
      setIsLoading(true);
      getEmailList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, cType]);

  const {
    // create: createAccess,
    // view: viewAccess,
    // update: updateAccess,
    delete: deleteAccess,
  } =
    userDetails?.role_data?.find(
      (item) => item?.permission_name === 'Inbox/Notifications'
    )?.sub_permission || {};

  const activeClass = 'cps-20 cpe-20 cpt-8 cpb-8 bg-new-car color-white text-16-500 br-5';
  const inActiveClass = 'p-2 color-black-olive text-16-500 pointer';
  const { user_type: userType } = getDataFromLocalStorage();

  return (
    <>
      {['0', '1', '6'].includes(userType) && (
        <Card className="d-flex align-items-center justify-content-between p-1 unset-br mb-3">
          <div className="d-flex align-items-center flex-wrap gap-3 cpb-4 cpt-4 cps-14 cpe-14">
            <div
              className={type === 'whatsapp' ? activeClass : inActiveClass}
              onClick={() => {
                navigate(`/${memberType}/inbox-notifications/whatsapp`);
              }}
            >
              Whatsapp
            </div>
            <div
              className={type === 'iferp' ? activeClass : inActiveClass}
              onClick={() => {
                navigate(`/${memberType}/inbox-notifications/iferp`);
              }}
            >
              IFERP
            </div>
            <div
              className={type === 'call-tracker' ? activeClass : inActiveClass}
              onClick={() => {
                navigate(`/${memberType}/inbox-notifications/call-tracker`);
              }}
            >
              Call Tracker
            </div>
          </div>
        </Card>
      )}

      {!['0', '1', '6'].includes(userType) ? (
        <Card className="d-flex align-items-center justify-content-between p-1 unset-br mb-3">
          <div className="d-flex align-items-center flex-wrap gap-2">
            <div
              className={type === 'inbox' ? activeClass : inActiveClass}
              onClick={() => {
                navigate(`/${memberType}/inbox-notifications/inbox`);
              }}
            >
              Inbox
            </div>
            <div
              className={type === 'compose' ? activeClass : inActiveClass}
              onClick={() => {
                navigate(`/${memberType}/inbox-notifications/compose`);
              }}
            >
              Compose
            </div>
            <div
              className={type === 'sent-messages' ? activeClass : inActiveClass}
              onClick={() => {
                navigate(`/${memberType}/inbox-notifications/sent-messages`);
              }}
            >
              Sent Messages
            </div>
            <div
              className={
                type === 'starred-messages' ? activeClass : inActiveClass
              }
              onClick={() => {
                navigate(`/${memberType}/inbox-notifications/starred-messages`);
              }}
            >
              Starred Messages
            </div>
            <div
              className={type === 'notifications' ? activeClass : inActiveClass}
              onClick={() => {
                navigate(`/${memberType}/inbox-notifications/notifications`);
              }}
            >
              Notifications
            </div>
          </div>
          {deleteIds.length > 0 && deleteAccess === '1' && (
            <Button
              text="Delete"
              btnStyle="primary-dark"
              className="h-35"
              btnLoading={deleteLoading}
              icon={<i className="bi bi-trash text-16-400 color-white me-2" />}
              onClick={() => {
                handelDeleteMessage({ index_array: deleteIds });
              }}
            />
          )}
        </Card>
      ) : (
        <>
          {type === 'iferp' && (
            <Card className="d-flex align-items-center justify-content-between p-2 unset-br mb-3">

              <div className="d-flex align-items-center flex-wrap gap-2">

                <div
                  className={cType === 'compose' ? activeClass : inActiveClass}
                  onClick={() => {
                    navigate(
                      `/${memberType}/inbox-notifications/iferp/compose`
                    );
                  }}
                >
                  Compose
                </div>

                <div
                  className={
                    cType === 'sent-messages' ? activeClass : inActiveClass
                  }
                  onClick={() => {
                    navigate(
                      `/${memberType}/inbox-notifications/iferp/sent-messages`
                    );
                  }}
                >
                  Sent Messages
                </div>
                <div
                  className={cType === 'inbox' ? activeClass : inActiveClass}
                  onClick={() => {
                    navigate(`/${memberType}/inbox-notifications/iferp/inbox`);
                  }}
                >
                  Inbox
                </div>
                <div
                  className={
                    cType === 'starred-messages' ? activeClass : inActiveClass
                  }
                  onClick={() => {
                    navigate(
                      `/${memberType}/inbox-notifications/iferp/starred-messages`
                    );
                  }}
                >
                  Starred Messages
                </div>
                <div
                  className={
                    cType === 'notifications' ? activeClass : inActiveClass
                  }
                  onClick={() => {
                    navigate(
                      `/${memberType}/inbox-notifications/iferp/notifications`
                    );
                  }}
                >
                  Notifications
                </div>
              </div>
              {deleteIds.length > 0 && deleteAccess === '1' && (
                <Button
                  text="Delete"
                  btnStyle="primary-dark"
                  className="h-35"
                  btnLoading={deleteLoading}
                  icon={
                    <i className="bi bi-trash text-16-400 color-white me-2" />
                  }
                  onClick={() => {
                    handelDeleteMessage({ index_array: deleteIds });
                  }}
                />
              )}
            </Card>
          )}
        </>
      )}

      {type === 'whatsapp' && <Whatsapp />}
      {type === 'call-tracker' && <CallTracker />}
      {(type === 'compose' || cType === 'compose') && <Compose />}

      {(type === 'inbox' || cType === 'inbox') && (
        <List
          listType={type === 'iferp' ? cType : type}
          isLoading={isLoading}
          msgList={msgList}
          deleteIds={deleteIds}
          handelDeleteId={handelDeleteId}
          handelDeleteMessage={handelDeleteMessage}
          handelStarMessage={handelStarMessage}
        />
      )}

      {(type === 'sent-messages' || cType === 'sent-messages') && (
        ['6'].includes(userType) ?
          <NewList
            listType={type === 'iferp' ? cType : type}
            isLoading={isLoading}
            msgList={msgList}
            deleteIds={deleteIds}
            handelDeleteId={handelDeleteId}
            handelDeleteMessage={handelDeleteMessage}
            handelStarMessage={handelStarMessage}
          /> :
          <List
            listType={type === 'iferp' ? cType : type}
            isLoading={isLoading}
            msgList={msgList}
            deleteIds={deleteIds}
            handelDeleteId={handelDeleteId}
            handelDeleteMessage={handelDeleteMessage}
            handelStarMessage={handelStarMessage}
          />
      )}

      {(type === 'starred-messages' || cType === 'starred-messages') && (
        <List
          listType={type === 'iferp' ? cType : type}
          isLoading={isLoading}
          msgList={msgList}
          deleteIds={deleteIds}
          handelDeleteId={handelDeleteId}
          handelDeleteMessage={handelDeleteMessage}
          handelStarMessage={handelStarMessage}
        />
      )}
      {(type === 'notifications' || cType === 'notifications') && (
        <Notifications />
      )}
    </>
  );
};
export default InboxNotifications;
